import { useQuery } from '@apollo/client';
import { graphql } from '../gql';
import { useMemo } from 'react';
import { getPaginatedNodes } from './utils';

const GET_COUNTRY = graphql(`
  query getCountries {
    countries(pagination: { first: 500 }) {
      edges {
        cursor
        node {
          name
          isoNumericCode
          uuid
          iso2Code
          iso3Code
        }
      }
    }
  }
`);

export function useGetCountryQuery() {
  const { loading, error, data } = useQuery(GET_COUNTRY, {});

  const { countries } = useMemo(() => {
    return {
      countries: getPaginatedNodes(data?.countries),
    };
  }, [data]);

  return {
    loading,
    error,
    data,
    countries,
  };
}
